module.exports = __webpack_public_path__ + "static/media/phone_suite_call_icon.ae7902fc.png";